import React from "react";
import { graphql } from "gatsby";
import ContentReferenceCard from "../../molecules/Cards/ContentReference";

export const ParagraphNodeGoodPractice = ({ node }) => {
  return (
    <div>
      <ContentReferenceCard
        title={node.title}
        imageURL={
          node?.relationships?.field_gp_thumbnail_image?.relationships?.field_media_image
            ?.gatsbyImage
        }
        eyebrowText={
          node?.relationships?.field_product_tags?.name || "Publication"
        }
        authorDetails={node?.relationships?.field_authors}
        field_country={node?.relationships?.field_country}
        field_theme={node?.relationships?.field_theme}
        linkTo={"/good-practice?id=" + node.field_practice_id }
        fieldSubtitle={node?.field_subtitle?.value}
        body={node?.body}
      />
    </div>
  );
};

export const fragment = graphql`
  fragment ParagraphNodeGoodPractice on node__good_practice {
    title
    field_practice_id
    fields {
      slug
    }
    field_subtitle {
      value
    }
    body {
      summary
      value
    }
    relationships {
      field_gp_thumbnail_image {
        relationships {
          field_media_image {
            gatsbyImage(width: 1000, quality: 100, placeholder: BLURRED)
          }
        }
      }
      field_authors {
        name
        relationships {
          field_author_image {
            relationships {
              field_media_image {
                gatsbyImage(
                  width: 50
                  height: 50
                  quality: 100
                  placeholder: BLURRED
                )
              }
            }
          }
        }
      }
      field_country {
        name
      }
      field_product_tags {
        name
      }
      field_theme {
        name
      }
      field_region {
        name
      }
    }
  }
`;

export default ParagraphNodeGoodPractice;
